"use client";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./LoginPage.css";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth(); // Obtiene la función login del contexto

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // --- LOG: Verificando la URL base de la API ---
  console.log("API_BASE_URL configurada:", API_BASE_URL);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsLoading(true);

    // --- LOG: Variables que se van a enviar ---
    console.log("Enviando credenciales:", { username, password: "******" }); // No loguear la contraseña real por seguridad

    try {
      const requestBody = JSON.stringify({ username, password });
      const requestUrl = `${API_BASE_URL}/auth/login`;

      // --- LOG: Datos que se envían y a dónde ---
      console.log("Enviando solicitud POST a:", requestUrl);
      console.log("Cuerpo de la solicitud (JSON):", requestBody);

      const response = await fetch(requestUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestBody,
      });

      // --- LOG: Respondió la API ---
      console.log("Respuesta recibida del servidor (estado):", response.status);
      console.log("Respuesta recibida del servidor (OK):", response.ok);

      if (!response.ok) {
        const errorData = await response.json();
        // --- LOG: Datos de error si la respuesta no es OK ---
        console.error("Error en la respuesta (status no OK):", errorData);
        throw new Error(
          errorData.message || "Error de autenticación. Intente de nuevo."
        );
      }

      const data = await response.json();
      // --- LOG: Datos recibidos si la respuesta es OK ---
      console.log("Datos recibidos exitosamente:", data);

      // Llama a la función login del contexto para almacenar el token y el usuario
      login(data.token, data.user);

      // --- LOG: Redirigiendo ---
      console.log("Redirigiendo a /admin");
      navigate("/admin");
    } catch (err) {
      // --- LOG: Error durante el fetch o procesamiento ---
      console.error("Error de inicio de sesión (catch):", err.message);
      setError(err.message);
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
      // --- LOG: Finalizando el proceso de carga ---
      console.log("Proceso de inicio de sesión finalizado. isLoading:", false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <h2 className="login-title">Iniciar Sesión</h2>
        <p className="login-description">
          Accede a tu cuenta para gestionar la plataforma de certificados
          digitales.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Usuario
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
              disabled={isLoading}
              placeholder="Ingresa tu usuario"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Contraseña
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              disabled={isLoading}
              placeholder="Ingresa tu contraseña"
              required
            />
          </div>

          {error && (
            <div className="login-error-message">
              {
                "Disculpa, ocurrio un error. Por favor comuniquese con soporte, gracias."
              }
            </div>
          )}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? "Iniciando sesión..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
export default LoginPage;
